// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.app-container {
  height: 100%;
  margin-top: 12px;
  padding: 0 1rem;
}

.chat-global-container {
  display: flex;
  flex-direction: column;
  position: fixed;
  right: 16px;
  bottom: 24px;
  z-index: 10000;
}
.chat-global-container .delete-fab,
.chat-global-container .edit-fab {
  display: none;
}
.chat-global-container:hover .delete-fab,
.chat-global-container:hover .edit-fab {
  display: block;
}
.chat-global-container i {
  color: var(--white-color);
}
.chat-global-container .chat-bg-color {
  background: var(--ai-chat-icon);
  height: 48px !important;
  width: 48px !important;
}`, "",{"version":3,"sources":["webpack://./src/app/app.component.scss"],"names":[],"mappings":"AAAA;EACE,YAAA;EACA,gBAAA;EACA,eAAA;AACF;;AAEA;EACE,aAAA;EACA,sBAAA;EACA,eAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;AACF;AACE;;EAEE,aAAA;AACJ;AAII;;EAEE,cAAA;AAFN;AAME;EACE,yBAAA;AAJJ;AAOE;EACE,+BAAA;EACA,uBAAA;EACA,sBAAA;AALJ","sourcesContent":[".app-container {\n  height: 100%;\n  margin-top: 12px;\n  padding: 0 1rem;\n}\n\n.chat-global-container {\n  display: flex;\n  flex-direction: column;\n  position: fixed;\n  right: 16px;\n  bottom: 24px;\n  z-index: 10000;\n\n  .delete-fab,\n  .edit-fab {\n    display: none;\n  }\n\n  &:hover {\n\n    .delete-fab,\n    .edit-fab {\n      display: block;\n    }\n  }\n\n  i {\n    color: var(--white-color);\n  }\n\n  .chat-bg-color {\n    background: var(--ai-chat-icon);\n    height: 48px !important;\n    width: 48px  !important;\n  }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
